import { PopoverProps } from '@mui/material/Popover';

import Box from '../Box/Box.jsx';
import Popover from '../Popover/Popover.jsx';
import Typography from '../Typography/Typography.jsx';

export interface FilterButtonPopoverProps {
  popoverContent?: React.ReactNode | null;
  popoverProps?: Partial<PopoverProps>;
  onClose: () => void;
  open: boolean;
  popoverTitle?: string;
}

const FilterButtonPopover = ({
  open,
  popoverContent,
  popoverProps,
  onClose,
  popoverTitle,
}: FilterButtonPopoverProps) => {
  return (
    <Popover
      open={open}
      id="simple-popover"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      onClose={onClose}
      {...popoverProps}
      sx={{
        '.MuiPopover-paper': {
          paddingBottom: '4px',
        },
        ...popoverProps?.sx,
      }}
    >
      <Typography
        variant="overline01"
        padding="8px 12px 2px 12px"
        color="text.secondary"
      >
        {popoverTitle}
      </Typography>
      <Box>{popoverContent}</Box>
    </Popover>
  );
};

export default FilterButtonPopover;
